export interface EmployeeCardSearchDto {
    page: number;
    limit: number;
    search?: string;
    sort?: string;
    sortDir?:  'ASC' | 'DESC';
    merchantId?: number;
    merchantGroupId?: number;
    employeeActiveStatus?: boolean;
    cardActiveStatus?: boolean;
}